<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="阶段" prop="schedule" >
        <a-select v-model="form.schedule" placeholder="请选择阶段">
          <a-select-option :value="0">
            全部
          </a-select-option>
          <a-select-option :value="1">
            初赛
          </a-select-option>
          <a-select-option :value="2">
            复赛
          </a-select-option>
          <a-select-option :value="3">
            决赛
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="管理学校" prop="schoolId" >
        <a-select placeholder="请选择管理学校" optionFilterProp="children" show-search v-model="form.schoolId">
          <a-select-option v-for="(item, index) in schoolList" :key="index" :value="item.id" >
            {{ item.cityName + '-' + item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="用户手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入用户手机号" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompetitionManage, addCompetitionManage, updateCompetitionManage } from '@/api/platform/competitionManage'
import {listSchool} from "@/api/platform/school"

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      competitionType: null,
      schoolList: [],
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        competitionId: null,

        schoolId: null,

        userId: null,

        createTime: null,

        remark: null,

        schedule: null,

        type: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
    this.schoolInit();
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        competitionId: null,
        userId: null,
        createTime: null,
        remark: null,
      }
    },
    // eslint-disable-next-line vue/no-dupe-keys
    schoolInit () {
      listSchool({}).then(response => {
        this.schoolList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (competitionId, competitionType) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.competitionId = competitionId
      this.competitionType = competitionType
      //this.schoolInit()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids, competitionType) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompetitionManage({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        this.competitionType = competitionType
      })
      //this.schoolInit()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompetitionManage(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompetitionManage(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
